import { motion } from "framer-motion";

export default function Reveal({
    children,
    delay = 0,
    y = 28,
    className = "",
    ...rest
}) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
            {...rest}
        >
            {children}
        </motion.div>
    );
}
